export default function ParamUpdateMidiNormalized(actionContext, payload) {
	return actionContext.dispatch('PARAMETER_CHANGE_MIDI', payload);
}